import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { REDUCER_NAME } from './slice';

export const getRoot = prop(REDUCER_NAME);

export const getVisibleStateById = createSelector(
	getRoot,
	(state, id) => id,
	(state, id, initiallyOpen) => initiallyOpen,
	(state, id, initiallyOpen) => propOr(initiallyOpen, id)(state),
);
